import { render, staticRenderFns } from "./dom.vue?vue&type=template&id=6edf7500&scoped=true&"
import script from "./dom.vue?vue&type=script&lang=js&"
export * from "./dom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf7500",
  null
  
)

export default component.exports